<template>
  <div>
    <div class="page-header">
      <div class="page-header-index-wide">
        <a-breadcrumb class="breadcrumb">
          <a-breadcrumb-item>
            <router-link :to="{ path: '/' }">首页</router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <span>基础设置</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <span>项目配置</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
        <div class="detail">
          <div class="main">
            <div class="row">
              <h1 class="title">项目配置</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ak-setting :options="options" />
  </div>
</template>

<script>
import store from '@/store'
export default {
  data () {
    return {
      options: [
        {
          title: '订单删除密码',
          inputs: [
            {
              name: 'deleteOrderPassword',
              note: '删除密码',
              type: 'String',
              validators: [
                (val) => val ? null : '删除密码不可为空'
              ],
              disabled: !store.state.user.authority.setting.edit
            }
          ]
        },
        {
          title: '订单售价分式',
          inputs: [
            {
              name: 'dynamicVariable',
              note: '分式变量值1 (%)',
              type: 'Number',
              validators: [
                (val) => val ? null : '分式变量值不得为空'
              ],
              disabled: !store.state.user.authority.setting.edit
            }, {
              name: 'dynamicVariable1',
              note: '分式变量值2 (%)',
              type: 'Number',
              validators: [
                (val) => val ? null : '分式变量值不得为空'
              ],
              disabled: !store.state.user.authority.setting.edit
            }, {
              name: 'dynamicVariable3',
              note: '分式变量值3 (%)',
              type: 'Number',
              validators: [
                (val) => val ? null : '分式变量值不得为空'
              ],
              disabled: !store.state.user.authority.setting.edit
            },
            {
              name: 'dynamicVariable4',
              note: '分式变量值4 (%)',
              type: 'Number',
              validators: [
                (val) => val ? null : '分式变量值不得为空'
              ],
              disabled: !store.state.user.authority.setting.edit
            },
            {
              name: 'dynamicVariable5',
              note: '分式变量值5 (%)',
              type: 'Number',
              validators: [
                (val) => val ? null : '分式变量值不得为空'
              ],
              disabled: !store.state.user.authority.setting.edit
            }
          ]
        },
        {
          title: '吨提成设置',
          inputs: [
            {
              name: 'amountCommission',
              note: '吨提成基数',
              type: 'Number',
              validators: [
                (val) => val ? null : '吨提成基数',
                (val) => val >= 0 ? null : '请输入正确的数字'
              ],
              disabled: !store.state.user.authority.setting.edit
            }
          ],
        },
        // {
        //   title: '测试视频',
        //   inputs: [
        //     {
        //       name: 'testVideo',
        //       type: 'Video'
        //     }
        //   ]
        // }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
  .page-header {
    background: #fff;
    padding: 16px 32px 0;
    border-bottom: 1px solid #e8e8e8;
    margin: -24px -24px 24px -24px;
    .breadcrumb {
      margin-bottom: 16px;
    }
    .detail {
      display: flex;
      /*margin-bottom: 16px;*/
      .avatar {
        flex: 0 1 72px;
        margin: 0 24px 8px 0;
        & > span {
          border-radius: 72px;
          display: block;
          width: 72px;
          height: 72px;
        }
      }
      .main {
        width: 100%;
        flex: 0 1 auto;
        .row {
          display: flex;
          width: 100%;
          .avatar {
            margin-bottom: 16px;
          }
        }
        .title {
          font-size: 20px;
          font-weight: 500;
          font-size: 20px;
          line-height: 28px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          margin-bottom: 16px;
          flex: auto;
        }
        .logo {
          width: 28px;
          height: 28px;
          border-radius: 4px;
          margin-right: 16px;
        }
        .content,
        .headerContent {
          flex: auto;
          color: rgba(0, 0, 0, 0.45);
          line-height: 22px;
          .link {
            margin-top: 16px;
            line-height: 24px;
            a {
              font-size: 14px;
              margin-right: 32px;
            }
          }
        }
        .extra {
          flex: 0 1 auto;
          margin-left: 88px;
          min-width: 242px;
          text-align: right;
        }
        .action {
          margin-left: 56px;
          min-width: 266px;
          flex: 0 1 auto;
          text-align: right;
          &:empty {
            display: none;
          }
        }
      }
    }
  }
  .mobile .page-header {
    .main {
      .row {
        flex-wrap: wrap;
        .avatar {
          flex: 0 1 25%;
          margin: 0 2% 8px 0;
        }
        .content,
        .headerContent {
          flex: 0 1 70%;
          .link {
            margin-top: 16px;
            line-height: 24px;
            a {
              font-size: 14px;
              margin-right: 10px;
            }
          }
        }
        .extra {
          flex: 1 1 auto;
          margin-left: 0;
          min-width: 0;
          text-align: right;
        }
        .action {
          margin-left: unset;
          min-width: 266px;
          flex: 0 1 auto;
          text-align: left;
          margin-bottom: 12px;
          &:empty {
            display: none;
          }
        }
      }
    }
  }
</style>
